import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { Col, Row } from "reactstrap";
import createMarkup from "../../helpers/createMarkup";

// Encabezado de página del sistema de diseño: título grande y descripción
// sobre el fondo de la app, sin tarjeta ni ilustración de esquina (antes era
// una tarjeta con corner-4.png). `image` se sigue aceptando para no romper
// las llamadas existentes, pero ya no se dibuja.
const PageHeader = ({
  title,
  titleTag: TitleTag = "h3",
  description,
  image, // eslint-disable-line no-unused-vars
  col = { lg: 8 },
  leftDecoration,
  rightDecoration,
  children,
  className,
  ...rest
}) => (
  <header className={classNames("hl-page-header", className)} {...rest}>
    <Row className="align-items-end">
      {leftDecoration && leftDecoration}
      <Col {...col}>
        <TitleTag className="hl-page-header__title">{title}</TitleTag>
        {description && (
          <p
            className={classNames("hl-page-header__description", { "mb-0": !children })}
            dangerouslySetInnerHTML={createMarkup(description)}
          />
        )}
        {children}
      </Col>
      {rightDecoration && rightDecoration}
    </Row>
  </header>
);

PageHeader.propTypes = {
  title: PropTypes.any.isRequired,
  titleTag: PropTypes.string,
  description: PropTypes.string,
  col: PropTypes.shape(Col.propTypes),
  image: PropTypes.string,
  className: PropTypes.string,
  children: PropTypes.node,
};

export default PageHeader;
